import React, { createContext, useContext, useEffect, useState } from 'react';

export const RoleContext = createContext(null);

export const RoleProvider = ({ children }) => {
    const [role, setRole] = useState(() => {
        return sessionStorage.getItem('role') || null;
    });

    useEffect(() => {
        if (role) {
            sessionStorage.setItem('role', role);
        }
    }, [role]);

    return (
        <RoleContext.Provider value={{ role, setRole }}>
            {children}
        </RoleContext.Provider>
    );
};

export const useRole = () => useContext(RoleContext);
